/* Florame story v296 — spring disclosure, in-view portraits and automatic retraction */
(() => {
  const SELECTOR = '[data-flp-story]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialiseStory(section) {
    if (section.dataset.flpStoryInitialised === 'true') return;
    section.dataset.flpStoryInitialised = 'true';

    const toggle = section.querySelector('[data-flp-story-toggle]');
    const toggleLabel = section.querySelector('[data-flp-story-toggle-label]');
    const details = section.querySelector('[data-flp-story-details]');
    const detailsInner = details?.firstElementChild;
    if (!toggle || !details || !detailsInner) return;

    let expanded = false;
    let resizeObserver = null;

    const getExpandedHeight = () => (
      window.matchMedia('(max-width: 640px)').matches
        ? detailsInner.offsetHeight
        : detailsInner.scrollHeight
    );

    const syncHeight = () => {
      if (!expanded) return;
      details.style.height = `${getExpandedHeight()}px`;
    };

    const setExpanded = (next, options = {}) => {
      if (expanded === next) return;
      expanded = next;
      section.classList.toggle('is-story-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggleLabel.textContent = expanded ? 'Richiudi' : 'Scopri di più';
      details.setAttribute('aria-hidden', String(!expanded));
      details.inert = !expanded;

      if (expanded) {
        details.style.height = `${getExpandedHeight()}px`;
      } else {
        details.style.height = `${details.getBoundingClientRect().height}px`;
        window.requestAnimationFrame(() => { details.style.height = '0px'; });
        if (options.restoreFocus) toggle.focus({ preventScroll: true });
      }
    };

    toggle.addEventListener('click', () => setExpanded(!expanded));

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(syncHeight);
      resizeObserver.observe(detailsInner);
    }

    if (reduceMotion.matches) section.classList.add('is-story-visible');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-story-visible');
      return;
    }

    const revealObserver = reduceMotion.matches ? null : new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        section.classList.add('is-story-visible');
        revealObserver.disconnect();
      }, { threshold: .12, rootMargin: '0px 0px -10% 0px' });

    const retractObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry.isIntersecting && expanded) setExpanded(false);
    }, { threshold: 0, rootMargin: '-4% 0px -4% 0px' });

    revealObserver?.observe(section);
    retractObserver.observe(section);

    document.addEventListener('shopify:section:unload', () => {
      revealObserver?.disconnect();
      retractObserver.disconnect();
      resizeObserver?.disconnect();
    }, { once: true });
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(initialiseStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
